export default "__VITE_ASSET__2f9d9bfb__"